<template>
    <b-modal ref="confirmationModal" title="Confirmation" @ok="confirmDelete" centered>
        {{confirmText}}
    </b-modal>
  </template>
  
  <script>
  export default {
    props: ['confirmText'],
    methods: {
      confirmDelete() {
        this.$emit('action-confirmed');
      },
      openModal() {
        this.$refs.confirmationModal.show();
      },
    },
  };
  </script>